import { IError } from '@checkout/errors';
import { RootState } from '@checkout/state';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { resetErrors } from '../../../reducers/checkout';
import { Messages } from '../../presentational';
import messages from './../../../i18n/base-en';
import * as Styles from './Overlay.scss';

interface IOwnProps { }

interface IConnectedProps {
  errors?: IError;
}

interface IConnectetDispatchProps {
  resetErrors: typeof resetErrors;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class Overlay extends React.Component<Props, {}> {

  closeOverlay = () => {
    this.props.resetErrors();
  }

  render() {
    const { errors, intl } = this.props;
    const { formatMessage } = intl;

    if (!errors || errors.uiType !== 'overlay') { return null; }

    return (errors && (
      <div className={Styles.overlay}>
        <Messages type="error" title={formatMessage(messages.error_header)} errors={errors} onClick={this.closeOverlay} />
      </div>
    ));
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      errors: state.checkout.errors,
    }),
    {
      resetErrors
    }
  )
)(Overlay);
